import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'enumKeysSort',
  standalone: false
})
export class EnumKeysSortPipe implements PipeTransform {
  transform(value: any, onlyNumericKeys: boolean = false) : any {
    let keys = [];
    for (var enumMember in value) {
      if (!onlyNumericKeys || !isNaN(parseInt(enumMember, 10))) {
        keys.push({key: parseInt(enumMember, 10), value: value[enumMember]});
      } 
    }
     return keys.sort((a, b) => a.value.localeCompare(b.value));
  }
}